import {
  BlogCard,
  BlogError,
  BlogTags,
  BottomGraphic,
  FadeIn,
  Footer,
  GradientBg,
  Header,
  Pagination,
} from "../../../components"
import { api } from "../../../ghostClient"
import {
  Pagination as GhostPagination,
  PostOrPage,
  Tag,
} from "@tryghost/content-api"
import { GetServerSideProps } from "next"
import Link from "next/link"
import React from "react"

export interface Props {
  posts: PostOrPage[]
  tags: Tag[]
  pagination: GhostPagination
  hasError?: boolean
}

export default function BlogPage({ posts, pagination, tags, hasError }: Props) {
  return (
    <>
      <div className="overflow-hidden">
        <GradientBg />
        <Header />

        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 mt-24">
          <div className="text-center">
            <FadeIn>
              <h1 className="text-4xl tracking-tight font-extrabold text-alt sm:text-5xl md:text-6xl">
                Blog
              </h1>
            </FadeIn>
            <FadeIn>
              <p className="mt-3 max-w-2xl mx-auto text-xl text-gray-500 sm:mt-4">
                Welcome to the Coverdash insurance blog. Here you&rsquo;ll find
                valuable articles tailored to your business needs, so you can be
                ready in a dash for whatever comes next.
              </p>
            </FadeIn>
            {hasError ? (
              <BlogError />
            ) : (
              <div className="mt-6 md:flex md:justify-between md:items-end text-left">
                <BlogTags tags={tags} />
              </div>
            )}
          </div>
        </div>

        <div className="mx-auto max-w-7xl grid gap-5 lg:grid-cols-3 px-4 sm:px-6 lg:px-8 mt-8 mb-12">
          {posts.length ? (
            posts.map((post) => <BlogCard key={post.id} post={post} />)
          ) : (
            <div className="text-center lg:col-span-3">
              <p className=" text-xl text-gray-500">No posts</p>
              <Link
                className="mt-1 text-cdgreen-600 hover:text-cdgreen-700"
                href="/blog"
              >
                Back to blog
              </Link>
            </div>
          )}
        </div>

        <div className="mx-auto max-w-7xl mt-12 mb-20">
          <Pagination pagination={pagination} />
        </div>
      </div>

      <BottomGraphic />
      <Footer />
    </>
  )
}
export const getServerSideProps: GetServerSideProps = async (context) => {
  let error = null
  const posts = await api.posts
    .browse({
      formats: ["html", "plaintext"],
      page: Number(context?.params?.page),
      limit: 9,
      include: "tags",
      fields: [
        "id",
        "title",
        "slug",
        "excerpt",
        "published_at",
        "feature_image",
        "reading_time",
      ],
    })
    .catch((err) => {
      console.error(err)
      error = err
    })

  const tags = await api.tags.browse()

  return {
    props: {
      posts,
      pagination: posts?.meta.pagination,
      tags,
      hasError: error,
    },
  }
}
